var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getTypesetDOMStyle, parseTypesetStyle } from '../libs';
import { FORMAT_TYPE } from './const';
import { updateSchema } from './normalize';
import { Block, Formattable, SchemaMeta, SylSchema } from './schema';
// a root type of editor
var Doc = /** @class */ (function (_super) {
    __extends(Doc, _super);
    function Doc() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'doc';
        _this.content = 'block+';
        return _this;
    }
    return Doc;
}(SylSchema));
var Paragraph = /** @class */ (function (_super) {
    __extends(Paragraph, _super);
    function Paragraph() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'paragraph';
        _this.defining = false;
        _this.defaultFontSize = 16;
        _this.canMatch = function (dom) { return true; };
        _this.formatAttrs = function (v, dom) { return v; };
        _this.attrs = {
            align: {
                default: '',
            },
            class: {
                default: '',
            },
            lineIndent: {
                default: '',
            },
            spaceBefore: {
                default: '',
            },
            spaceAfter: {
                default: '',
            },
            spaceBoth: {
                default: '',
            },
            lineHeight: {
                default: '',
            },
        };
        _this.parseDOM = [
            {
                tag: 'p',
                priority: 20,
                getAttrs: function (dom) {
                    if (!_this.canMatch(dom))
                        return false;
                    var style = dom.getAttribute('style') || '';
                    return _this.formatAttrs(__assign(__assign({}, parseTypesetStyle(style, undefined, _this.defaultFontSize)), { class: dom.className }), dom);
                },
            },
        ];
        _this.toDOM = function (node) {
            var attrs = {};
            var style = getTypesetDOMStyle(node.attrs, _this.attrs);
            if (style)
                attrs.style = style;
            if (node.attrs.class)
                attrs.class = node.attrs.class;
            return ['p', attrs, 0];
        };
        return _this;
    }
    return Paragraph;
}(Block));
var Text = /** @class */ (function (_super) {
    __extends(Text, _super);
    function Text() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = 'text';
        _this.group = 'inline';
        return _this;
    }
    return Text;
}(SylSchema));
var Break = /** @class */ (function (_super) {
    __extends(Break, _super);
    function Break() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.group = 'inline';
        _this.inline = true;
        _this.name = 'break';
        _this.selectable = false;
        _this.content = undefined;
        _this.parseDOM = [{ tag: 'br' }];
        _this.toDOM = function () { return ['br']; };
        return _this;
    }
    return Break;
}(Formattable));
var basicSchema = updateSchema({
    nodes: {},
    marks: {},
}, [
    new SchemaMeta(FORMAT_TYPE.BLOCK, 'doc', new Doc()),
    new SchemaMeta(FORMAT_TYPE.BLOCK, 'paragraph', new Paragraph()),
    new SchemaMeta(FORMAT_TYPE.ATOM, 'text', new Text()),
    new SchemaMeta(FORMAT_TYPE.ATOM, 'break', new Break()),
]);
export { basicSchema, Break, Doc, Paragraph, Text };
//# sourceMappingURL=basics.js.map